import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import ErrorBoundaryComponent from './common/ui/ErrorBoundaries.js'

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min"
import './index.css';
// Warm modern theme. ⚠ Imported LAST, after bootstrap and index.css, so it wins
// on source order without needing !important. Moving this line above either of
// them silently reverts most of the restyle.
// Presentational only — remove this one line to revert the whole redesign.
import './theme.css';

// // ============ Export as function component ============
export function WebOrderingApp() {
  return (
    <React.StrictMode>
      <ErrorBoundaryComponent>
        {/* === Injecting ===
          1. Uncomment BrowserRouter with basename
          2. Put  <  "homepage": "/WebOrdering.aspx",  > into package.json between the "scripts" and "eslintConfig"
          3. Comment out BrowerRouter without basename
        */}

        {/* <BrowserRouter basename='/WebOrdering.aspx'>  */}

        {/* === Regular build ===
          1. Uncomment BrowerRouter without basename
          2. Remove "homepage" from package.json
          3. Comment out BrowserRouter with basename
        */}

        <BrowserRouter>

          <App />
        </BrowserRouter>
      </ErrorBoundaryComponent>
    </React.StrictMode>
  )
}
// === Commented out to instead render inside the injected client ===
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<WebOrderingApp />);





// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
